// Import the functions you need from the SDKs you need

import { initializeApp } from 'firebase/app';

// TODO: Add SDKs for Firebase products that you want to use

// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration

const firebaseConfig = {
  apiKey: 'AIzaSyCEPptcm6K9Qplr6QOGGMf0Vm_YLx7NsCA',

  authDomain: 'playlist-generator-12584.firebaseapp.com',

  projectId: 'playlist-generator-12584',

  storageBucket: 'playlist-generator-12584.appspot.com',

  messagingSenderId: '91625701318',

  appId: '1:91625701318:web:893597200fb31886f73cc7',
};

// Initialize Firebase

const firebase = initializeApp(firebaseConfig);

export default firebase;
